import { useSessionStore } from '@/stores'
import { cn } from '@utils'
import type { WelcomeMessageData } from '@/types'
import { interpolateTemplate, sessionTokens } from '../utils/omp'
import { HeadingSize } from '@/constants'

interface OmpWelcomeMessageProps {
  data: WelcomeMessageData
}

const SIZE_CLASS: Record<string, string> = {
  small: 'text-fluid-xl',
  medium: 'text-fluid-2xl',
  large: 'text-fluid-3xl',
}

const OmpWelcomeMessage = ({ data }: OmpWelcomeMessageProps) => {
  const session = useSessionStore(s => s.session)
  const heading = interpolateTemplate(data.heading, sessionTokens(session))

  if (!heading) {
    return null
  }

  return (
    <div
      role="heading"
      aria-level={1}
      className={cn('omp-welcome rich-text', SIZE_CLASS[data.text_size || HeadingSize.Medium])}
      dangerouslySetInnerHTML={{ __html: heading }}
    />
  )
}

export default OmpWelcomeMessage
